// eslint-disable-next-line import/prefer-default-export
export const SET_SELECTED_TAG_IDS = 'setSelectedTagIds';
